import axios from '../../plugins/axios';

/**
 * ÐÐ¾ÑÐ°Ð±Ð¾ÑÐºÐ° Ð·Ð°ÑÐ²ÐºÐ¸ MyCar: Ð´Ð¾ÑÑÐ»Ð°ÐµÐ¼ Ð±Ð°Ð½ÐºÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð¸ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°.
 *
 * Ð§ÐµÑÐµÐ· plugins/api Ð½ÐµÐ»ÑÐ·Ñ: ÑÐ°Ð¼ Ð²ÑÐµÐ³Ð´Ð° Content-Type application/json, Ð¸ Ð¿Ð¾Ð»Ñ
 * ÑÐ¾ÑÐ¼Ñ Ð´Ð¾ Ð±ÑÐºÐ° Ð½Ðµ Ð´Ð¾ÑÐ¾Ð´ÑÑ â appealId Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ð» Ð¿ÑÑÑÑÐ¼, Ð¸ Ð¾ÑÐ²ÐµÑÐ¾Ð¼ Ð±ÑÐ»Ð¾
 * Â«ÐÐ°ÑÐ²ÐºÐ° MyCar Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð°Â». Ð¤Ð°Ð¹Ð»Ñ Ñ Ð½Ð°Ñ Ð²ÐµÐ·Ð´Ðµ ÑÑÐ¾Ð´ÑÑ ÑÐ°Ðº Ð¶Ðµ, ÑÐµÑÐµÐ· axios.
 */
const sendMyCarUpdate = ({ appealId, comment, documentType, file }) => {
  const form = new FormData();
  form.append('appealId', appealId);
  if (comment) form.append('comment', comment);
  if (documentType) form.append('documentType', documentType);
  if (file) form.append('file', file);
  return axios.post('/crm/creditPlatform/mycar/updateApplication', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default sendMyCarUpdate;
